import scrollama from "scrollama";

const ScrollerSlides = {
    init(slidesStep) {
        const scroller = scrollama();

        let slides = document.querySelectorAll('.sticky-content .slide');

        // add ratioPercent variable to object that is accessible in other functions //28
        //this.ratioPercent = 42;
        this.ratioPercent = slides.length > 4 ? 42 : 28;
        if (slides.length > 5) {
            this.ratioPercent = 51;
        }

        //console.log(slidesStep.offsetWidth);
        //console.log(window.innerHeight);
        //console.log('ratio: ' + slidesStep.offsetWidth / window.innerHeight);

        let ratio = slidesStep.offsetWidth / window.innerHeight;
        let stickyDiv = document.querySelector('.sticky-div');
        if (window.innerWidth > 1200) {
            let containerWidth = Math.min( stickyDiv.getBoundingClientRect().width , window.innerWidth);
            //this.ratioPercent = (1 / (window.innerWidth/560) * 100).toFixed(1);
            //this.ratioPercent = (1 / (containerWidth/520) * 100).toFixed(1);
            //console.log(this.ratioPercent, slidesStep.offsetHeight);





            //this.ratioPercent = (window.innerWidth - (stickyDiv.getBoundingClientRect().width + slides.getBoundingClientRect().x)) / stickyDiv.getBoundingClientRect().width  * 100;


            //console.log(this.ratioPercent);
            if (window.innerWidth < 1536) {
                //this.ratioPercent = 52;
                //this.ratioPercent = 41;

                this.ratioPercent = slides.length > 4 ? 52 : 41;
                if (slides.length > 5) {
                    this.ratioPercent = 60;
                }
            }
            //document.querySelector('.slide-section').style.height = slidesStep.offsetHeight + window.innerHeight*0.8*1.3  + 'px';
            let heightIdx =  slides.length > 4 ? 1.7 : 1.2;
            document.querySelector('.slide-section').style.height = slidesStep.offsetHeight + window.innerHeight * heightIdx  + 'px';
            //document.querySelector('.slide-section').style.height = '2150px';

            //console.log('height: ', parseFloat(slidesStep.offsetHeight) + parseInt(window.innerHeight));
            scroller
                .setup({
                    step: ".slide-section",
                    debug: false,
                    progress: true,
                    offset: 0
                })
                .onStepEnter(response => this.handleStepEnter(response, slidesStep))
                .onStepExit(response => this.handleStepExit(response, slidesStep))
                .onStepProgress(response => this.handleStepProgress(response, slidesStep));
        }


    },
    handleStepEnter(response, slidesStep) {
        document.querySelector('.sticky-div').style.position = 'fixed';
        slidesStep.querySelectorAll('.slide').forEach((slide, idx) => {
            if (idx > 0) {
                slide.classList.add('active');
            }
        });
    },
    handleStepExit(response, slidesStep) {
        document.querySelector('.sticky-div').style.position = 'sticky';
        slidesStep.querySelectorAll('.slide').forEach((slide, idx) => {
            if (idx > 0) {
                //slide.classList.remove('active');
            }
        });
    },
    handleStepProgress(response, slidesStep) {

        let progress = 100 * response.progress;
        if (progress <= this.ratioPercent) {
            slidesStep.style.transform = 'translate3d(-' + progress + '%, 0px, 0px)';
        }
        /*if (window.innerWidth > 1200) {
            if (progress < 35) {
                slidesStep.style.transform = 'translate3d(-' + progress + '%, 0px, 0px)';
            }
        } else {
            if (progress < 60) {
                slidesStep.style.transform = 'translate3d(-' + progress + '%, 0px, 0px)';
            }
        }*/
    }


    // resize on window resize


}

export default ScrollerSlides;




